import { lazy } from "react";
import { Outlet } from "react-router";

import experienceRoutes from "./experience/experienceRoutes";
import bookingRoutes from "./booking/bookingRoutes";
import lookingGlassRoutes from "./looking-glass/lookingGlassRoutes";

const Home = lazy(() => import("./common/components/Home"));
const Experience = lazy(() => import("./experience/components/Experience"));
const Booking = lazy(() => import("./booking/components/Booking"));

const dashboardRoutes = [
  { index: true, element: <Home /> },
  {
    path: "experience",
    element: <Experience />,
    children: experienceRoutes,
  },
  { path: "booking", element: <Booking />, children: bookingRoutes },
  {
    path: "ld-looking-glass",
    element: <Outlet />,
    children: lookingGlassRoutes,
  },
];

export default dashboardRoutes;
